module.exports = __webpack_public_path__ + "cece61711439d26ca44883066f0d18f7.png";